import {
	isApplicationProfileDeactivated,
	isProfileAvailabilityConflict
} from '~/utils/applicationAvailability'

export function filterAcceptedInterviewApplications(applications, selectedIds) {
	const ids = Array.isArray(selectedIds) ? selectedIds : []

	return (Array.isArray(applications) ? applications : []).filter(
		application =>
			ids.some(id => id == application?.id) &&
			application?.status === 'accepted'
	)
}

export default {
	data() {
		return {
			showInterviewInvitationModal: false,
			interviewInvitationApplications: [],
			interviewInvitationContext: {},
			interviewInvitationSubmitting: false,
			interviewInvitationSending: false
		}
	},
	computed: {
		interviewInvitationApplicationIds() {
			return this.interviewInvitationApplications
				.map(application => application?.id)
				.filter(Boolean)
		}
	},
	methods: {
		applicationFromStore(applicationId) {
			return this.$store.state.application.applications.find(
				application => application.id == applicationId
			)
		},
		shouldOpenInterviewInvitation(applicationOrId, status) {
			const application =
				typeof applicationOrId === 'object'
					? applicationOrId
					: this.applicationFromStore(applicationOrId)

			return Boolean(
				status === 'interview' &&
					this.$isOrgContext &&
					application &&
					application.status !== 'interview' &&
					!isApplicationProfileDeactivated(application)
			)
		},
		openInterviewInvitationModal(applications, context = {}) {
			const normalized = (Array.isArray(applications)
				? applications
				: [applications]
			).filter(Boolean)

			if (
				normalized.length !== 1 ||
				normalized.some(isApplicationProfileDeactivated)
			) {
				return
			}

			this.interviewInvitationApplications = normalized
			this.interviewInvitationContext = context
			this.showInterviewInvitationModal = true
		},
		closeInterviewInvitationModal() {
			if (
				this.interviewInvitationSubmitting ||
				this.interviewInvitationSending
			) {
				return
			}

			this.showInterviewInvitationModal = false
			this.interviewInvitationApplications = []
			this.interviewInvitationContext = {}
		},
		hideInterviewInvitationModal() {
			this.showInterviewInvitationModal = false
		},
		clearInterviewInvitationModal() {
			this.showInterviewInvitationModal = false
			this.interviewInvitationApplications = []
			this.interviewInvitationContext = {}
		},
		normalizePageScrollAfterInterviewMove() {
			if (
				typeof window === 'undefined' ||
				typeof document === 'undefined'
			) {
				return
			}

			this.$nextTick(() => {
				const scheduleFrame = window.requestAnimationFrame
					? window.requestAnimationFrame.bind(window)
					: callback => setTimeout(callback, 0)

				scheduleFrame(() => {
					const scrollingElement =
						document.scrollingElement || document.documentElement
					const scrollHeight = Math.max(
						scrollingElement?.scrollHeight || 0,
						document.documentElement?.scrollHeight || 0,
						document.body?.scrollHeight || 0
					)
					const maxScrollTop = Math.max(
						0,
						scrollHeight - window.innerHeight
					)
					const currentScrollTop =
						window.pageYOffset ??
						window.scrollY ??
						scrollingElement?.scrollTop ??
						0

					if (currentScrollTop > maxScrollTop) {
						window.scrollTo({
							top: maxScrollTop,
							left: window.pageXOffset || 0,
							behavior: 'auto'
						})
					}
				})
			})
		},
		async dispatchInterviewInvitationMove(payload) {
			if (this.interviewInvitationSubmitting) return []
			if (!this.interviewInvitationApplicationIds.length) return []

			this.interviewInvitationSubmitting = true

			try {
				const result = await this.$store.dispatch(
					'application/moveToInterview',
					payload
				)

				this.clearInterviewInvitationModal()
				this.normalizePageScrollAfterInterviewMove()

				return result
			} catch (error) {
				if (isProfileAvailabilityConflict(error))
					this.clearInterviewInvitationModal()
				throw error
			} finally {
				this.interviewInvitationSubmitting = false
			}
		}
	}
}
